import {
    NotificationIdentifierModel,
    NotificationIdentifierModelFromJson,
    JsonNotificationIdentifierModel,
} from './notification-identifier.model';
import { MATERIAL_ORDER_PRIORITY } from '../../types/material-order-priority';
import { MaterialModel, MaterialModelFromJson, JsonMaterialModel } from './material.model';
import { MaterialCheckModel, MaterialCheckModelFromJson, JsonMaterialCheckModel } from './material-check.model';
import { CseDopModel, CseDopModelFromJson, JsonCseDopModel } from '../complex/cse-dop.model';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { NotificationDataInstanceToken } from '../../interfaces/notification-data.interface';

export class LocalStorageNotificationMaterialOrderModel {
    public constructor(
        public notificationIdentifier: NotificationIdentifierModel,
        public priority: MATERIAL_ORDER_PRIORITY,
        public materials: MaterialModel[],
        // The raw material-check partSet (as returned by the availability/pricing check), kept alongside
        // `materials` because it carries fields such as `extUnit` that `MaterialModel` does not, and that
        // the unit-based splitting logic in MaterialOrderComponent.setMaterialOptions() needs on restore.
        public partSet: MaterialCheckModel[],
        public address: CseDopModel,
        public textInfo: string,
        public deliveryOptions: string,
        public isSubmitted: boolean,
        public lastSavedTimestamp = 0,
        public customerApprover?: string,
    ) {}
}

export class LocalStorageNotificationMaterialOrderModelFromJson extends LocalStorageNotificationMaterialOrderModel {
    public constructor(data: JsonLocalStorageNotificationMaterialOrderModel) {
        const injector = CustomInjector.getInjector();
        const notificationService = injector.get(NotificationDataInstanceToken);
        super(
            new NotificationIdentifierModelFromJson(data.notificationIdentifier),
            <MATERIAL_ORDER_PRIORITY>data.priority,
            data.materials.map((jsonOrderedMaterial) => {
                const notification = notificationService.getNotificationByIdentifier(
                    new NotificationIdentifierModelFromJson(jsonOrderedMaterial.notificationIdentifier),
                );
                return new MaterialModelFromJson(jsonOrderedMaterial, notification);
            }),
            data.partSet
                ? data.partSet.map((jsonMaterialCheck) => new MaterialCheckModelFromJson(jsonMaterialCheck))
                : [],
            data.address ? new CseDopModelFromJson(data.address) : new CseDopModel(),
            data.textInfo ? data.textInfo : '',
            data.deliveryOptions ? data.deliveryOptions : '',
            typeof data.isSubmitted !== 'undefined' ? data.isSubmitted : true,
            data.lastSavedTimestamp ?? 0,
            data.customerApprover,
        );
    }
}

export interface JsonLocalStorageNotificationMaterialOrderModel {
    notificationIdentifier: JsonNotificationIdentifierModel;
    priority: string;
    materials: JsonMaterialModel[];
    partSet?: JsonMaterialCheckModel[];
    address: JsonCseDopModel;
    textInfo: string;
    deliveryOptions: string;
    isSubmitted: boolean;
    lastSavedTimestamp: number;
    selectedStateOfUS: string;
    customerApprover?: string;
}
